export default {
  drawLine: 'リンク',
  drawLineComponent: 'リンクコンポーネント',
  viewDrawLineArea: '開始および終了領域を表示',
  setDrawLineArea: '開始および終了領域を設定',
  onlyOneDrawLineTip:
    '同じシーン内でのリンクコンポーネントまたは自由描画コンポーネントの追加は1つのみサポートされています。',
  addGroupWarning: 'リンクコンポーネントをグループ化禁止',
  setDrawLine: 'リンクコンポーネントの設定',
  drawLineEdit: {
    drawLineArea: '開始および終了領域',
    addDrawLineArea: '開始および終了領域の追加',
    pairRelation: 'ペアリング関係',
    pairWay: 'ペアリング方法',
    pairCategory: 'ペアリングのカテゴリ',
    addPairRelation: 'ペアリング関係の追加',
    pairDefaultName: 'ペアリング',
    areaPlaceholder: '開始および終了領域を選択',
    noAreaTip: '最初に開始および終了領域を追加してください',
    notAllowLineAgain: 'リンク成功後、リンクを再び行うことはできません',
    lineStyle: 'ラインスタイル',
    lineSizePlaceholder: 'ラインの太さ',
    applyToOther: 'すべてに適用',
    preview: 'すべてのリンクラインをプレビュー',
    closePreview: 'プレビューを閉じる',
    renameIsTooLongTip: '{len}文字以内のみサポートされます',
    renameIsEmptyTip: '名前は空白にできません',
    deletePairConfirmTip:
      '既にマッチングされているペアリング関係が削除されます。本当に削除しますか？',
    deleteAreaConfirmTip:
      '既に開始および終了領域がマッチングされているペアリング関係が削除されます。本当に削除しますか？',
    cancel: 'キャンセル',
    ok: '削除',
    category: {
      addCategory: 'ペアカテゴリを追加',
      enterCategoryPlaceholder: 'ペアカテゴリを入力してください',
      nameDuplicateTip:
        '既存のカテゴリと同じ名前のペアカテゴリは使用できません。',
      nameRegTip:
        '英数字およびアンダースコアのみサポートされており、20文字を超えてはいけません。',
      deleteComfirm: '削除すると元に戻すことはできません。削除しますか？',
      noData: 'データはありません',
      noDataTip: 'ボタンをクリックしてペアカテゴリを追加',
    },
    match: {
      isMatch: 'マッチしますか',
      placeholder: '選択してマッチ',
      match: 'マッチ',
      noMatch: 'マッチしない',
      pairPlaceholder: 'ペアリング関係を選択',
      pairWayPlaceholder: 'ペアリング方法を選択してください',
      pairCategoryPlaceholder: 'ペアリングカテゴリを選択してください',
    },
    lineDir: {
      title: 'ラインペアリング',
      singleDir: '片方向',
      doubleDir: '両方向',
    },
    lineType: {
      title: 'ラインタイプ',
      trajectoryLine: 'フリーハンド描画',
      straightLine: '直線',
    },
    splitText: '[開始および終了領域の位置およびサイズ] 横と縦の画面分割',
    splitTip:
      '横と縦の画面で、現在の開始および終了領域の位置とサイズを異なる値に設定できます。',
    vpEraseLineTip: '直線にのみ適用され、軌跡線には適用されません',
    vpModifyLineStyleTip:
      '軌跡線：描画されていない線は適用されず、描画されている線は適用されます。<br/>直線：描画された線と描画されていない線の両方に適用されます。',
    vpModifyPairLineStyle: '直線にのみ適用され、軌跡線には適用されません',
    pairTip: 'リンク済みの起動領域は線を引くことができません。',
    areaTip:
      'このエリアから描かれた線のスタイルの設定。<br/>このエリアに対してペアリングの関係を設定する必要があり、線を描くことができます。',
  },
  freeDrawLine: 'フリーハンドライン',
  freeDrawLineComponent: 'フリーハンドラインコンポーネント',
  setFreeDrawLine: '線のスタイルを設定する',
  setFreeDrawLineStyle: '線のスタイル',
  freeDrawLineEdit: {
    tab: '線',
    preview: '線のプレビュー',
    closePreview: 'プレビューを閉じる',
    vpFreeEraseLineTip: '描かれた線をすべてクリア',
    vpFreeModifyLineStyleTip:
      '未描画の線にのみ有効で、描画されたものには影響しません。',
  },
}
